import { getOptions } from 'containers/OutBidding/api';
import React, { createContext, useContext, useEffect, useState } from 'react';
import { isBlank } from 'utils/object';

export const OptionsContext = createContext<Record<string, any>>({});

export const OptionsContextProvider = (props: any) => {
  const { children, productId } = props;
  const [optionsMap, setOptionsMap] = useState({});

  // 获取 filter 数据
  useEffect(() => {
    if (isBlank(productId)) return;

    const params: any = {
      keys: [
        'demand_categories',
        // 'priorities',
        // 'demand_new_product_user',
        'quote_currencies',
        'product',
        'bidding_business',
        'bidding_types',
        'bidding_methods',
        // 'bidding_evaluation_member',
        // 'bidding_evaluation_admin',
      ],
      group_type: 'CHANNEL_GROUP',
      demand_state: 'PENDING_DESIGN',
      product_ids: [productId],
    };
    getOptions(params).then((res: any = {}) => {
      const mapOptions = res.data.reduce((pre: any, cur: any) => {
        let option = cur.options || [];
        let key = cur.key;
        if (cur.key === 'bidding_evaluation_member') {
          option = option.map((v: any) => ({
            value: v.member_id,
            name: `${v.name} ${v.value}`,
          }));
        }
        if (cur.key === 'bidding_business') {
          key = 'business';
        }
        return {
          ...pre,
          [key]: option,
        };
      }, {});
      setOptionsMap(mapOptions);
    });
  }, [productId]);

  return (
    <OptionsContext.Provider value={optionsMap}>
      {children}
    </OptionsContext.Provider>
  );
};

export const ExtraContext = createContext<Record<string, any>>({});

export const ExtraContextProvider = (props: any) => {
  const { children, ...reset } = props;
  return (
    <ExtraContext.Provider value={reset}>{children}</ExtraContext.Provider>
  );
};

export const useExtra = () => {
  return useContext(ExtraContext);
};
